import {Provider} from "@angular/core";
import {HTTP_INTERCEPTORS} from "@angular/common/http";
import {AuthInterceptor} from "./_auth/auth.interceptor";
import {ErrorInterceptor} from "./_auth/error.interceptor";
import {DateInterceptor} from "./x-interceptors/date.interceptor";
import {DuplicateRequestInterceptor} from "./x-interceptors/duplicate-request.interceptor";

// Registration order IS request-flow order (outermost first). DuplicateRequestInterceptor MUST stay first so
// it wraps the whole chain: a deduped caller shares the in-flight response without re-running Auth/Error/Date,
// so their side-effects (notably ErrorInterceptor's 401→logout) fire exactly once per real request — see
// docs/articles/frontend/http-request-deduplication.md. Do not move it below the others.
export const INTERCEPTOR_PROVIDERS: Provider[] = [
  {
    provide: HTTP_INTERCEPTORS, useClass: DuplicateRequestInterceptor, multi: true
  }, {
    provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true
  }, {
    provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true
  }, {
    provide: HTTP_INTERCEPTORS, useClass: DateInterceptor, multi: true
  }
]
